<section [ngClass]="[isLightGreyBG ? 'light-grey padded-large' : 'padded-large']">
    <div class="pamphlet">
        <ng-content></ng-content>
    </div>
</section>